import React from 'react';
import { Table } from 'reactstrap';
import moment from 'moment-timezone';

const RecordTable = props => {
  return (
    <Table responsive hover className="ps-table tb-col-3">
      <thead>
        <tr>
          <th>Order ID</th>
          <th>Status</th>
          <th>Record DateTime</th>
        </tr>
      </thead>
      <tbody>
        {props.state.record.length < 1 && (
          <tr>
            <td colSpan="3">
              <div className="ps-empty-data">
                <div className="empty-content">
                  <h4>No data to show</h4>
                </div>
              </div>
            </td>
          </tr>
        )}

        {props.state.record.length > 0 &&
          props.state.record.map((item, index) => {
            return (
              <tr key={index}>
                <td>{item.order_id}</td>
                <td>{item.order_status}</td>
                <td>
                  {moment(item.record_dt)
                    .tz('Asia/Singapore')
                    .format('YYYY-MM-DD HH:MM:SS')}
                </td>
              </tr>
            );
          })}
      </tbody>
    </Table>
  );
};

export default RecordTable;
